import { Check, ArrowRight } from 'lucide-react';
import { services, additionalServices } from '../../mock';

export default function Services() {
  const requestQuote = (title) => {
    const prefill = `I'd like a quote for ${title}.`;
    sessionStorage.setItem('quote_service', prefill);
    window.dispatchEvent(new CustomEvent('prefill-quote', { detail: prefill }));
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="services" className="py-24 cream-bg">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-14 reveal">
          <p className="section-label mb-4">Services</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05]">
            Choose the right service to keep your property sharp.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div
              key={s.title}
              className="reveal group relative rounded-lg overflow-hidden"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="relative h-[380px] overflow-hidden">
                <img src={s.image} alt={s.title} width="520" height="380" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A2E18] via-[#0A2E18]/70 to-[#0A2E18]/10" />
                <div className="absolute top-4 left-4">
                  <div className="w-11 h-11 rounded-full bg-[#0A2E18] border border-[#D98A00]/70 flex items-center justify-center text-[#D98A00] font-bold text-sm">
                    {String(i + 1).padStart(2, '0')}
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="text-2xl font-extrabold mb-2 text-white">
                    {s.title}
                  </h3>
                  <p className="text-white/85 text-sm leading-relaxed mb-4">{s.desc}</p>
                  <button
                    type="button"
                    onClick={() => requestQuote(s.title)}
                    data-testid={`service-quote-btn-${s.title.toLowerCase().replace(/\s+/g, '-')}`}
                    className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-[#D98A00] hover:bg-[#B86F00] text-[#0A2E18] text-xs font-bold tracking-wide uppercase transition-colors shadow-sm"
                  >
                    Get a Quote <ArrowRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional services */}
        <div className="mt-12 pt-10 border-t border-[#E2DAC5] text-center">
          <p className="section-label mb-4">Also Available</p>
          <h3 className="text-2xl md:text-3xl font-extrabold mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
            More garden &amp; property services
          </h3>
          <ul className="flex flex-wrap items-center justify-center gap-2.5 max-w-3xl mx-auto">
            {additionalServices.map((label) => (
              <li key={label}>
                <button
                  type="button"
                  onClick={() => requestQuote(label)}
                  data-testid={`additional-service-quote-btn-${label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-white border-2 border-[#0A2E18]/25 text-[#0A2E18] text-sm font-bold hover:border-[#1B6E37] hover:bg-[#F2ECE0] hover:shadow-md transition-all cursor-pointer"
                >
                  <Check className="w-3.5 h-3.5 text-[#1B6E37]" aria-hidden="true" />
                  {label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
